var windowW       = $(window).width();
var windowH       = $(window).innerHeight();

var _isSP;
var windowW = window.innerWidth;
var prewidth = window.innerWidth;

//preload
import {preload} from "../include/module";
preload();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

$(window).on('load' , function() {

  setTimeout(function(){$('.sw-Ttl').addClass("is-animated");},0);
  setTimeout(function(){$('.st-Lower_Contents').addClass("is-animated");},600);
  storySlide();

});

// ------------------------------------------------------------------------
// storySlide
// ----- BOTH
// ------------------------------------------------------------------------
const storySlide = () => {

  var storySwiper01;
  let options01 = {};
  options01 = {
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
    autoHeight: false,
    loop: true,
    loopAdditionalSlides: 1,//一瞬の途切れがなくなり、2周目以降も途切れることなくループできる
    grabCursor: true,
    watchOverflow: true,//スライドの枚数がスライダー生成の条件に満たさない時）、コントロール関係を削除してスライド機能もなくす。
    speed: 800,
    // width: 760,
    centeredSlides: true,
    pagination: {
      el: '.swiper-pagination_01',
    },
  }

  storySwiper01 = new Swiper('.swiper-container_01', options01);


  var storySwiper02;
  let options02 = {};
  options02 = {
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
    autoHeight: false,
    loop: true,
    loopAdditionalSlides: 1,//一瞬の途切れがなくなり、2周目以降も途切れることなくループできる
    grabCursor: true,
    watchOverflow: true,//スライドの枚数がスライダー生成の条件に満たさない時）、コントロール関係を削除してスライド機能もなくす。
    speed: 800,
    // width: 760,
    centeredSlides: true,
    pagination: {
      el: '.swiper-pagination_02',
    },
  }

  storySwiper01 = new Swiper('.swiper-container_02', options02);

};



// WEBPACK FOOTER //
// ./src/morfonica-anime_v0/assets/js/story/script.js